import styled from "styled-components";

export const layout = styled.div`
width: 100vw;
    display: grid;
    grid-template-columns: min(26rem,25vw) 3fr 1fr;
    grid-template-rows: 100vh;
    grid-template-areas:'container-left main container-right';
    
    @media (max-width: 575.98px){
        grid-template-columns: 12vw 88vw;
        grid-template-rows: auto auto;
        grid-template-areas:
        'container-left main'
        'container-left second-row';
    }

    @media (min-width: 576px) and (max-width: 767px){
        grid-template-columns: 25vw 75vw;
        grid-template-rows: 38vh 35vh 50vh;
        grid-template-areas:
        'container-left main'
        'container-left second-row'
        'container-left third-row';
    }

    @media (min-width: 767.98px) and (max-width: 999.98px){
        grid-template-columns: 25vw 75vw;
        grid-template-rows: 38vh 42vh 50vh;
        grid-template-areas:
        'container-left main'
        'container-left second-row'
        'container-left third-row';
    }

`